// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { PrimaryText } from '../../Typography.jsx';
import { Button } from '../../Buttons.jsx';
import ContentBox from '../../ContentBox.jsx';

import styles from '../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  reportId: String,
  counselingReports: Object[],
  closePage: Function,
}

class ViewReportComponent extends React.Component<Props> {
  render() {
    const data = this.props.counselingReports.find(
      report => report._id === this.props.reportId,
    ) || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <ContentBox title='Counseling Report'>
        <div className={styles.notes}>
          <PrimaryText>Session Date</PrimaryText><br />
          {data.date ? moment(data.date).format('DD-MM-YYYY, HH:mm') : '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Counselor Name</PrimaryText><br />
          {data.counselorName || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Contact Details</PrimaryText><br />
          {data.contactDetails || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Department</PrimaryText><br />
          {data.department || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Case Referred By</PrimaryText><br />
          {data.caseReferredBy || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>General Topic for Session</PrimaryText><br />
          {data.generalTopic || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Background</PrimaryText><br />
          {data.background || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Session Notes</PrimaryText><br />
          {data.notes || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Findings</PrimaryText><br />
          {data.findings || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Plan of Action</PrimaryText><br />
          {data.planOfAction || '--'}
        </div>
        <div className={styles.notes}>
          <PrimaryText>Topics</PrimaryText><br />
          {data.topics ? data.topics.join(', ') : '--'}
        </div>
        <table>
          <tbody>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        <Button onClick={this.props.closePage}>Close</Button>
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  counselingReports: state.patient.data.counselingReports,
});

const ViewReportPage = connect(
  mapStateToProps,
)(ViewReportComponent);

export default ViewReportPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/counseling/ViewReportPage.jsx